<template lang="pug">
b-card.mb-1(no-body='')
  b-card-header.p-1.text-left(header-tag='header' role='tab')
    b-button.btn.text-left(block='' v-b-toggle.accordion-setting='' variant='primary') {{ $t('ui.setting') }}
  b-collapse#accordion-setting(visible=''  role='tabpanel')
    b-card-body
      b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
        .row
          .col-lg-6.col-12
            b-form-group(:label="$t('ui.site_name')").mb-1
              DebounceInput(
                size="sm"
                ref="site_name"
                required
                type="text"
                :dirty="$v.site_name.$dirty"
                :error="$v.site_name.$error"
                v-model.trim.lazy="$v.site_name.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.site_name" :name="$t('ui.site_name')")
            b-form-group(:label="$t('ui.language')").mb-1
              .table-responsive
                table.table.table-sm.table-bordered.table-striped.mb-0.table-align-middle
                  thead
                    tr.table-active
                      th(width="70%") {{ $t('ui.name') }}
                      th.text-center(width="30%") {{ $t('ui.default') }}
                  tbody
                    //- tr(v-for="item in languageList" v-if="item.lang_code == 'EN' || item.lang_code == 'CN' || item.lang_code == 'PHP'")
                    tr(v-for="item in languageList")
                      td(@click="selectLanguage(item)" :class="{ 'pointer': item.lang_code != 'EN' }")
                        template(v-if="item.lang_code != 'EN'")
                          input.align-middle(type='checkbox' name="langcheck" :disabled="item.lang_code == 'EN'" :checked="languages.includes(item.lang_code)" style="pointer-events: none;")
                        template(v-else)
                          i.fas.fa-check-circle.text-success
                        span.ml-2(:for="item.lang_code")
                          span {{ $t("ui.langList." + item.lang_code) }}
                      td.text-center.pointer(@click="setLanguageDefault(item)")
                        input(type='radio' v-model="langDefault" name="langdefault" :value="item.lang_code" style="pointer-events: none;")

                ValidateResult(:value="$v.languages" :name="$t('ui.language')")
            b-form-group(:label="$t('ui.logo')").mb-1
              template(v-if="logo.length <= 0")
                .file-drop-wrapper(
                  @dragover.prevent=''
                  @dragenter.prevent=''
                  @drop.prevent='onDropLogo')
                  b-form-file(
                    ref="file"
                    accept="image/jpeg, image/png, image/jpg"
                    @input="onSelect"
                    :state='null'
                  )
              template(v-else)
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="deleteImage(0)"
                  variant="danger"
                  size="sm"
                  )
                br
                img.img-fluid.logo-image-file(:src="logo[0].src" :id="logo[0].id")

              .text-xs.text-grey.mt-2.mb-3
                | {{ $t('message.needAiToGenerateLogo') }}? 
                span.section-subtitle.text-decoration-underline
                  a(href="https://www.logoai.com/logo-maker" target="_blank") logoai
              .text-xs.text-grey(style="line-height:0px") *{{ $t('message.uploadYourLogoWithPngFormat') }}
              .text-xs.text-grey.mt-1 *{{ $t('message.logoDimensionTips') }}
              .text-xs.text-grey.mt-1(style="line-height:0px") *{{ $t('message.noExtraSpacingInLogo') }}
              .text-xs.text-grey.mt-1 *{{ $t('message.allowedPngOnlyMaxOneMb') }}

          .col-lg-6.col-12
            .text-xs.text-grey(style="line-height:0px") *{{ $t('message.uploadYourManifestWithPngJpegFormat') }}, 512px x 512px
            .text-xs.text-grey.mt-1 *{{ $t('message.allowedPngAndJpegOnlyMaxOneMb') }}
            b-form-group.w-100(:label="$t('ui.manifest')").mb-0.mt-2
              .file-drop-wrapper(
                v-if="croppedImage == null"
                @dragover.prevent=''
                @dragenter.prevent=''
                @drop.prevent='onDrop')
                b-form-file(
                  v-model="selectedFile"
                  ref='fileInput'
                  @input='onFileChange'
                  accept="image/jpeg, image/png, image/jpg"
                  :state='null')

              SubmitButton.mt-2(
                :loading="loading"
                icon="fa fa-times"
                :text="$t('ui.remove')"
                type="button"
                @click="removeImage()"
                variant="danger"
                size="sm"
                v-if="croppedImage != null"
                )

              div(v-if='croppedImage')
                img(:src='croppedImage' alt='Cropped' width="512" height="512")

              ImageCropperModal(
                ref='cropperModal'
                :imageSrc='tempImageSrc'
                :originalWidth="originalWidth"
                :originalHeight="originalHeight"
                :originalFileName="originalManifestName"
                :originalFileType="originalManifestType"
                @crop-complete='onCropComplete'
                @crop-cancel='removeImage')

        div.float-right.mb-3
          SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" @click="confirmSubmit")
            i.fa.fa-save
            span.ml-1 {{ $t("ui.save") }}
          b-button.ml-2(type="button" variant="info" @click="callSync")
            i.fas.fa-sync-alt
            span.ml-1 {{ $t("ui.sync_all") }}
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const multiSelectOption = ((value) => value.length > 0);
import ImageCropperModal from '@/library/ImageCropperModal.vue'

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    ImageCropperModal
  },
  props: {
    siteId: {
      type: Number
    },
    siteInfo: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      site_name: '',
      languageList: [],
      languages: [],
      image_name: null,
      file: null,
      imageList: [],
      imageKey: 0,
      logo: [],
      langDefault: null,
      tempImageSrc: null,
      croppedImage: null,
      selectedFile: null,
      manifest_name: null,
      originalManifestName: '',
      originalWidth: 0,
      originalHeight: 0,
      originalManifestType: null,
      finalManifestFile: null
    };
  },
  validations: {
    site_name: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(50)
    },
    languages: {
      multiSelectOption
    }
  },
  computed: {
    selectedOperatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  mounted() {
    this.getLanguageList();
  },
  beforeDestroy() {
    this.loading = false
    this.feedback = {
      success: true,
      status: ""
    }
    this.name = ''
    this.languageList = []
    this.languages = []
    this.image_name = null
    this.file = null
    this.imageList = []
    this.imageKey = 0
    this.logo = []
    this.langDefault = null
    this.tempImageSrc = null
    this.croppedImage = null
    this.selectedFile = null
    this.manifest_name = null
    this.originalManifestName = ''
    this.originalWidth = 0
    this.originalHeight = 0
    this.originalManifestType = null
    this.finalManifestFile = null
  },
  methods: {
    setSettingVal() {
      var languageList = this.siteInfo.language
      for (var i = 0; i < languageList.length; i++) {
        this.languages.push(languageList[i].language);

        if(languageList[i].is_default) {
          this.langDefault = languageList[i].language
        }
      }
      this.site_name = this.siteInfo.site[0].site_name

      if (this.siteInfo.site[0].logo != null) {
        this.image_name = this.siteInfo.site[0].logo
        var imageId = this.image_name + "" + Math.random()

        var img = {
          name: this.image_name,
          existname: this.image_name,
          id: imageId,
          src: config.viewImageUrl + this.image_name
        };
        this.logo = [img]
      }

      if(this.siteInfo.site[0].manifest_icon != null) {
        this.manifest_name = this.siteInfo.site[0].manifest_icon
        this.croppedImage = config.viewImageUrl + this.siteInfo.site[0].manifest_icon
      }
    },
    setLanguageDefault(item) {
      this.langDefault = item.lang_code

      var languageIndex = this.languages.indexOf(item.lang_code)

      if(languageIndex < 0)
        this.languages.push(item.lang_code)
    },
    checkImg(file, isManifest) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

      if (!allowedTypes.includes(file.type)) {
        this.$helpers.showToast(this.$t("ui.alert"), this.$t("message.pleaseSelectAValidImageType"), "error");
        if(isManifest != true) {
          if (this.$refs.file && this.$refs.file.reset) {
            this.$refs.file.reset()
          }
        }
        return true;
      }
      if (file.size > 1000000) {
        this.$helpers.showToast(this.$t("ui.alert"), this.$t("message.imageTooLargeMaxSizeAllowedIsOneMb"), "error");
        if(isManifest != true) {
          if (this.$refs.file && this.$refs.file.reset) {
            this.$refs.file.reset()
          }
        }
        return true;
      }
      return false;
    },
    checkImgLogo(file) {
      const allowedTypes = ["image/png"];

      if (!allowedTypes.includes(file.type)) {
        this.$helpers.showToast(this.$t("ui.alert"), this.$t("message.pleaseSelectAValidImageType"), "error");
          if (this.$refs.file && this.$refs.file.reset) {
            this.$refs.file.reset()
          }
        return true;
      }
      if (file.size > 1000000) {
        this.$helpers.showToast(this.$t("ui.alert"), this.$t("message.imageTooLargeMaxSizeAllowedIsOneMb"), "error");
          if (this.$refs.file && this.$refs.file.reset) {
            this.$refs.file.reset()
          }
        return true;
      }
      return false;
    },
    onDrop(event) {
      const files = event.dataTransfer.files;
      if (files && files[0]) {
        this.handleFile(files[0]);
      }
    },
    onFileChange(file) {
      if (!(file instanceof File)) {
        return;
      }

      var invalidImage = this.checkImg(file, true);
      if (invalidImage) {
        this.removeImage()
        return;
      }

      this.handleFile(file);
    },
    handleFile(file) {
      const reader = new FileReader();

      reader.onload = () => {
        const minSize = 512;
        const img = new Image();
        img.onload = () => {
          this.originalWidth = img.naturalWidth
          this.originalHeight = img.naturalHeight

          if (img.naturalWidth >= minSize && img.naturalHeight >= minSize) {
            // Already big enough
            this.tempImageSrc = reader.result;
          } else {
            // Image too small
            const canvasWidth = Math.max(img.naturalWidth, minSize);
            const canvasHeight = Math.max(img.naturalHeight, minSize);

            const canvas = document.createElement('canvas');
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;

            const ctx = canvas.getContext('2d');

            // Center the image in the padded canvas
            const offsetX = (canvasWidth - img.naturalWidth) / 2;
            const offsetY = (canvasHeight - img.naturalHeight) / 2;

            ctx.drawImage(img, offsetX, offsetY, img.naturalWidth, img.naturalHeight);

            const scaledDataURL = canvas.toDataURL(file.type);
            this.tempImageSrc = scaledDataURL;
          }

          this.originalManifestName = file.name;
          this.originalManifestType = file.type

          this.$nextTick(() => {
            this.$refs.cropperModal.show();
          });
        };
        img.src = reader.result;
      };

      reader.readAsDataURL(file);
    },
    onCropComplete(file, croppedDataUrl) {
      this.finalManifestFile = file
      this.croppedImage = croppedDataUrl;
    },
    removeImage() {
      if (this.$refs.fileInput && this.$refs.fileInput.reset) {
        this.$refs.fileInput.reset()
      }
      this.selectedFile = null;
      this.croppedImage = null
      this.tempImageSrc = null
      this.manifest_name = null
      this.originalManifestName = null
      this.originalWidth = 0
      this.originalHeight = 0
      this.originalManifestType = null
      this.finalManifestFile = null
    },
    onDropLogo(event) {
      const files = event.dataTransfer.files;
      if (files && files[0]) {
        this.onSelect(files[0]);
      }
    },
    onSelect(file) {
      if (!(file instanceof File)) {
        return;
      }

      if (file != null) {
        var invalidImage = this.checkImgLogo(file);
        if (invalidImage)
          return;

        this.image_name = file.name;
        this.file = file;

        this.deleteImage(0);
        var imageId = this.image_name + "" + Math.random()

        var img = {
          name: this.image_name,
          file: this.file,
          id: imageId
        };

        var reader = new FileReader();
        reader.onload = function () {
          var imageElement = document.getElementById(imageId);
          imageElement.src = reader.result;
          img.src = imageElement.src
        }
        reader.readAsDataURL(this.file);

        this.logo.push(img)

        // $('#upload-logo-btn')[0].value = '';
      }
    },
    deleteImage(index) {
      if (this.$refs.file && this.$refs.file.reset) {
        this.$refs.file.reset()
      }
      this.image_name = null
      this.logo.splice(index, 1);
    },
    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    async confirmSubmit() {
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$invalid)
        return

      if (this.logo != null && this.logo.length > 0) {
        if(this.logo[0].existname == null || this.logo[0].existname != this.image_name) {
          const p1 = this.uploadLogo();
          const someResult = await p1;
        }
      }

      if(this.croppedImage != null && this.croppedImage != '') {
        if(this.siteInfo.site[0].manifest_icon == null || this.siteInfo.site[0].manifest_icon != this.manifest_name) {
          const p2 = this.uploadManifest();
          const anotherResult = await p2;
        }
      }

      this.saveSetting();
    },
    async uploadLogo() {
      const formData = new FormData();
      formData.append("file", this.file);

      this.loading = true;
      try {
        await this.$http.post(config.uploadImageUrl, formData).then(function(response) {
          this.loading = false;

          if (response.ok) {
            if (typeof response.data.file != "undefined") {
              if (response.data.file.filename) {
                this.image_name = response.data.file.filename
              } else {
                this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
              }
            } else {
              this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
            }
          } else {
            this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
          }
        });
      } catch (err) {
        this.loading = false;
        this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
      }
    },
    async uploadManifest() {
      const formData = new FormData();
      formData.append("file", this.finalManifestFile);

      this.loading = true;
      try {
        await this.$http.post(config.uploadImageUrl, formData).then(function(response) {
          this.loading = false;

          if (response.ok) {
            if (typeof response.data.file != "undefined") {
              if (response.data.file.filename) {
                this.manifest_name = response.data.file.filename
              } else {
                this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
              }
            } else {
              this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
            }
          } else {
            this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
          }
        });
      } catch (err) {
        this.loading = false;
        this.$helpers.showDialog(this.$t("ui.upload"), this.$t("error.uploadFailed"), "error");
      }
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getLanguageList: function() {
      let url = config.getLanguageListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        language: '',
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.languageList = response.data.dt;
                this.setSettingVal();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectLanguage(target) {
      if(target.lang_code == 'EN') return
      var languageIndex = this.languages.indexOf(target.lang_code)

      if(languageIndex < 0)
        this.languages.push(target.lang_code)
      else {
        this.languages.splice(languageIndex, 1)

        if(this.langDefault == target.lang_code) {
          this.langDefault = 'EN'
        }
      }
    },
    saveSetting() {
      let url = config.siteEditUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.selectedOperatorID,
        site_id: this.siteId,
        site_name: this.site_name,
        logo: this.image_name,
        manifest_icon: this.manifest_name
      };

      var langList = [];
      for(var i = 0; i < this.languages.length; i++) {
        var jsonLang = {
          language: this.languages[i],
          is_default: false
        }

        if(this.langDefault == this.languages[i])
          jsonLang.is_default = true

        langList.push(jsonLang)
      }
      json['languages'] = langList;

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$helpers.showDialog(this.$t("ui.combine.update_setting"), this.$t("message.success"), "success");
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.setSettingVal();
              }
            }
          } catch (error) {
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              this.setSettingVal();
            }
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
    },
    reset() {
      this.site_name = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    callSync() {
      this.$emit("callSync");
    }
  }
};
</script>